import axios from "axios";
import { NetworkCheckUploadOptions } from "../network-check";
import { ChipStatus } from "../../../../shared/ppr-chip-status/ppr-chip-status";
import { sleep } from "../../../../util/util";

export const DEFAULT_UPLOAD_CHECK: NetworkCheckUploadOptions = {
  minSpeed: Number(process.env.REACT_APP_UPLOAD_SPEED_MIN) ?? 0.384,
  url: process.env.REACT_APP_UPLOAD_SPEED_CHECK_URL ?? "",
  timeout: Number(process.env.REACT_APP_NETWORK_CHECK_TIMEOUT) ?? 20000,
};

export const checkUploadSpeed = async (uploadCheckOption: NetworkCheckUploadOptions): Promise<{ uploadSpeed: number, uploadStatus: ChipStatus }> => {
  await sleep(1000);

  let myData = "";
  for (let i = 0; i < 1024; i += 1) {
    myData += "k";
  }

  const startTime = new Date().getTime();
  try {
    const response = await axios.post(
      uploadCheckOption.url,
      { uploadData: myData },
      {
        headers: { "Content-Type": "application/json" },
        timeout: uploadCheckOption.timeout,
      },
    );

    if (response.status !== 200) {
      return {
        uploadSpeed: 0,
        uploadStatus: 'failed'
      };
    }

    const endTime = new Date().getTime();
    const duration = (endTime - startTime) / 1000;
    const speedKbps = 1024 / duration;
    const speedMbps = speedKbps / 1024;

    return {
      uploadSpeed: Number(speedMbps.toFixed(2)),
      uploadStatus: speedMbps >= uploadCheckOption.minSpeed ? 'passed' : 'failed'
    };
  } catch {
    return {
      uploadSpeed: 0,
      uploadStatus: 'failed'
    };
  }
};
